<script>
import axios from "axios";
import OcrPreviewModal from "./OcrPreviewModal.vue";

export default {
  components: {
    OcrPreviewModal,
  },
  props: {
    pagos: Object,
    proveedores: Array,
    postPago: Function,
    cancelar: Function,
  },
  data() {
    return {
      file: null,
      files: [],
      lista_proveedores: [],
      tipo_pago: "",
      tipo_documento_contable: "",
      monto: 0,
      fecha_pago: "",
      proveedor_id: "",
      proveedor_rut:"",
      nro_documento: null,

      ocrIsPending: undefined,
      ocrIsSuccess: undefined,

      submitIsPending: undefined,
      submitIsSuccess: undefined,

      previewUrl: null,
      showPreviewModal: false,
      ocrEngine: "",
    };
  },
  computed: {
    lista_tipos_pagos() {
      return (this.pagos?.tipos_pagos ?? []).map((tipo) => ({
        id: tipo.id,
        text: tipo.nombre,
      }));
    },
    fechaFormateada() {
      if (!this.fecha_pago) return "";
      return this.fecha_pago.split("-").reverse().join("-");
    },
    disableSubmit() {
      return this.ocrIsPending || this.submitIsPending;
    },
    enableOcr() {
      return (
        this.tipo_documento_contable?.index == 0 ||
        this.tipo_documento_contable?.index == 6
      );
    },
  },
  mounted() {
    this.lista_proveedores = [];
    this.proveedores.forEach((el) => {
      this.lista_proveedores.push({ id: el.id, text: el.nombre });
    });
  },
  watch: {
    file: function (e) {
      this.$refs["file-input"].files.forEach((el) => {
        this.files.push(el);
      });
      this.$refs["file-input"].reset();
    },
  },
  methods: {
    getProveedorNombre(id) {
      if (!id) return "No encontrado";
      const proveedor = this.lista_proveedores.find((p) => p.id == id);
      return proveedor ? proveedor.text : "No encontrado";
    },
    getTipoPagoNombre(id) {
      if (!id) return "No encontrado";
      const tipo = this.pagos?.tipos_pagos?.find((t) => t.id == id);
      return tipo ? tipo.nombre : "No encontrado";
    },
    closePreview() {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }
    },
    formatMonto() {
      this.monto = this.monto.toString().replace(/\D/g, "");
      let money = this.monto.toString().replace(/[.,$\s]/g, "");
      this.monto = new Intl.NumberFormat("es-CL", {
        currency: "CLP",
        style: "currency",
      }).format(money);
    },
    async requestOCR(file) {
      const validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
      if (!validTypes.includes(file.type)) {
        this.$swal({
          icon: 'warning',
          title: 'Formato no soportado',
          text: 'Por favor, suba un PDF o una imagen para realizar el OCR.'
        });
        return;
      }

      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }

      const formData = new FormData();
      formData.append("file", file);

      this.ocrIsPending = true;
      this.ocrIsSuccess = false;

      try {
        const { data } = await axios.post(`/api/payment-ocr`, formData);
        if (data?.data) {
          this.monto = data.data.monto ?? null;
          this.formatMonto();
          this.nro_documento = data.data.numero_documento ?? null;
          this.fecha_pago = data.data.fecha_emision ?? null;
          this.proveedor_id = data.data?.proveedor?.id ?? null;
          this.proveedor_rut = data.data?.proveedor?.rut ?? null;
          this.tipo_pago = data.data?.tipo_pagos_id ?? null;

          this.ocrEngine = data.engine;

          this.previewUrl = URL.createObjectURL(file);
          this.showPreviewModal = true;
          this.ocrIsSuccess = true;
        }
      } catch (err) {
        this.$swal({
          title: "Error",
          icon: "error",
          text:
            err.response?.data?.message ??
            err.response?.data?.error ??
            err.response?.error?.message ??
            "Hubo un error al hacer la solicitud de OCR",
        });
      } finally {
        this.ocrIsPending = false;
      }
    },
    async eliminar(file) {
      let variable = await this.$swal({
        title: "¿Deseas eliminar este documento de pago?",
        text: "¿Está seguro? ¡No podrás revertir esta acción!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Borrar!",
        cancelButtonText: "No, cancelar!",
        buttonsStyling: true,
      });
      if (variable.isConfirmed == true) {
        let encontro = false;
        this.files = this.files.filter((el) => {
          if (!encontro) {
            if (el.name == file.name) {
              encontro = true;
            } else {
              return el;
            }
          } else {
            return el;
          }
        });
      }
    },
    async noMultipleFilesAlert() {
      this.$swal({
        icon: "error",
        title: "Error",
        text: "No esta permitido hacer OCR para múltiples documentos",
      });
    },
    async submit() {
      let formData = new FormData();

      this.id = this.$route.params.despachoId;
      formData.append("despachos_id", this.id);
      formData.append("tipo_pagos_id", this.tipo_pago);
      formData.append(
        "tipo_documento_contable",
        this.tipo_documento_contable.tipo
      );
      formData.append("fecha_pago", this.fecha_pago);
      formData.append("proveedor_id", this.proveedor_id);
      formData.append(
        "monto",
        Number(this.monto.toString().replace(/\D/g, ""))
      );
      formData.append("nro_documento", this.nro_documento);

      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        formData.append("files[" + i + "]", file);
      }

      if (this.files.length > 0) {
        this.cancelar();

        this.submitIsPending = true;

        this.postPago(formData);

        this.submitIsPending = false;
        this.id = "";
        this.tipo_pago = "";
        this.tipo_documento_contable = "";
        this.monto = 0;
        this.nro_documento = 0;
        this.proveedor_id = "";
        this.fecha_pago = "";
        this.files = [];
        this.$refs["file-input"].files = [];
      } else {
        this.$swal({
          icon: "warning",
          title: "",
          text: "Se deben subir documentos para comprobar pago",
        });
      }
    },
  },
};
</script>

<template>
  <form @submit.prevent="submit" id="form-pagos" enctype="multipart/form-data">
    <div class="grid grid-cols-1 md:grid-cols-8 gap-8 text-left">
      <div class="md:col-span-3">
        <label>Tipo de documento contable </label>
        <select
          id="documento-select"
          v-model="tipo_documento_contable"
          required
        >
          <option value="" disabled>
            Seleccionar Tipo de documento Contable
          </option>
          <option
            v-for="(tipo, index) in pagos.tipo_documento_contable"
            :key="index"
            :value="{ index, tipo }"
          >
            {{ tipo }}
          </option>
        </select>
      </div>
      <div class="md:col-span-2">
        <label>Tipo de pago </label>
        <Select2
          class="mi-select2"
          v-model="tipo_pago"
          :options="lista_tipos_pagos"
          :required="true"
          :settings="{
            noResults: 'es',
            placeholder: 'Seleccione un Tipo de Pago',
            width: '100%',
            multiple: false,
          }"
        />
      </div>
      <div class="md:col-span-2">
        <label>Proveedor </label>
        <Select2
          class="mi-select2"
          v-model="proveedor_id"
          :options="lista_proveedores"
          :settings="{
            noResults: 'es',
            placeholder: 'Seleccione un Proveedor',
            width: '100%',
            multiple: false,
          }"
        />
      </div>
      <div class="col-span-1">
        <label>Monto </label>
        <input
          type="text"
          @keyup="formatMonto()"
          @keydown="formatMonto()"
          v-model="monto"
          required
        />
      </div>
      <div class="md:col-span-2">
        <label>Fecha Documento </label>
        <input type="date" max="12" v-model="fecha_pago" required />
      </div>

      <div class="md:col-span-2">
        <label>N° Documento </label>
        <input
          type="number"
          v-model="nro_documento"
          min="0"
          value=""
          required
        />
      </div>

      <div class="md:col-span-4">
        <div>
          <label>Adjuntar documento(s) </label>
          <b-form-file
            browse-text="Buscar"
            placeholder="Seleccione un archivo"
            drop-placeholder="Coloque el archivo aquí..."
            v-model="file"
            ref="file-input"
            class="mb-2"
            multiple
            @change="
              (event) => {
                if (event.target.files.length > 1) {
                  noMultipleFilesAlert();
                  return;
                }

                if (enableOcr && event.target.files.length > 0) {
                  requestOCR(event.target.files[0]);
                }
              }
            "
          ></b-form-file>
        </div>

        <div class="md:col-span-3">
          <button
            class="w-12 hover:scale-110 transition-all"
            v-b-tooltip.hover
            :title="file.name"
            type="button"
            v-for="(file, index) in files"
            :key="index"
            @click="eliminar(file)"
          >
            <inline-svg
              class="size-12"
              v-if="file.name.split('.').at(-1) == 'pdf'"
              src="../../assets/images/archivo-pdf.svg"
            />
            <inline-svg
              v-if="
                file.name.split('.').at(-1) == 'png' ||
                file.name.split('.').at(-1) == 'jpg' ||
                file.name.split('.').at(-1) == 'jpeg'
              "
              src="../../assets/images/archivo-png.svg"
            />
          </button>
        </div>
      </div>

      <b-modal
        v-model="ocrIsPending"
        no-backdrop
        hide-header
        hide-footer
        centered
      >
        <div class="p-8 flex flex-col gap-4 text-center items-center">
          <b-spinner class="text-primary" style="width: 3em; height: 3em" />
          <span class="">Realizando OCR ...</span>
        </div>
      </b-modal>

      <OcrPreviewModal
        v-model="showPreviewModal"
        :proveedorNombre="getProveedorNombre(proveedor_id)"
        :proveedorRut="proveedor_rut"
        :tipo-pago="getTipoPagoNombre(tipo_pago)"
        :monto="monto"
        :fechaFormateada="fechaFormateada"
        :nroDocumento="nro_documento"
        :previewUrl="previewUrl"
        :ocrEngine="ocrEngine"
        @hidden="closePreview"
      />

      <div
        class="col-span-1 sm:col-span-4 md:col-span-8 flex flex-row justify-between w-full items-center h-12"
      >
        <button
          class="btn-principal ml-auto"
          type="submit"
          :disabled="disableSubmit"
        >
          Enviar
        </button>
      </div>
    </div>
  </form>
</template>
